import { Color } from '@persona-id/design-tokens';
import styled from 'styled-components';

import GraphExplorerPanelItem from 'dashboard/components/GraphExplorerPanelItem/GraphExplorerPanelItem';
import TableLayout, { TableTD, TableTH, TableTR } from 'dashboard/layouts/TableLayout';
import { DatumTypeToken } from 'dashboard/models/graph';
import { FontWeight } from 'design-system/variables/text';
import { ACCOUNT_DATUM_TYPE } from 'lib/constants/graph';

const StyledTableTH = styled(TableTH)`
  font-weight: ${FontWeight.Regular};
  background-color: ${Color.CoreSlate50};
  padding: 0 0 4px 6px;
`;

const StyledTableTD = styled(TableTD)`
  border-bottom: none;
  padding: 0 0 4px 6px;
`;

interface GraphOverviewPanelItemProps {
  getVertexTypeCount: (datumTypeToken: DatumTypeToken) => number;
  // Only used as a way to rerender for refreshes.
  renderCount: number;
}

const EmptyTable = () => {
  return (
    <>
      <StyledTableTH>Category</StyledTableTH>
      <StyledTableTH>Count</StyledTableTH>
      <TableTR>
        <StyledTableTD>Total accounts</StyledTableTD>
        <StyledTableTD>-</StyledTableTD>
      </TableTR>
    </>
  );
};

const GraphOverviewPanelItem = ({ getVertexTypeCount }: GraphOverviewPanelItemProps) => {
  return (
    <GraphExplorerPanelItem label='Overview'>
      <TableLayout dataTest='graph-overview__table' nullState={<EmptyTable />} headerTR={<></>}>
        <TableTR>
          <StyledTableTD>Category</StyledTableTD>
          <StyledTableTD>Total Accounts</StyledTableTD>
        </TableTR>
        <TableTR>
          <StyledTableTD>Count</StyledTableTD>
          <StyledTableTD>{getVertexTypeCount(ACCOUNT_DATUM_TYPE.token)}</StyledTableTD>
        </TableTR>
      </TableLayout>
    </GraphExplorerPanelItem>
  );
};

export default GraphOverviewPanelItem;
